<script>
export default {
  data() {
    return {
      latestRequest: undefined
    }
  },
  methods: {
    async handleLatestRequest(requestFn, responseHandler) {
      this.latestRequest = requestFn
      const response = await requestFn()
      if (this.latestRequest === requestFn) {
        responseHandler(response)
      }
    }
  }
}
</script>
